import {Button} from '@folksam/ui-next/components'
export default Button